import {educationActions} from '../actions';
import * as Date from '../elements/dates/dateHelpers';

export default function education(initialState = {}, action) {
    const newState = {...initialState};
    switch (action.type) {
        case educationActions.SET_EDUCATION: return setEducationReducer(newState, action);
        case educationActions.GENERAL_EDUCATION_REQUEST: return setEducationReducer(newState, action);
        case educationActions.GENERAL_EDUCATION_SUCCESS: return createAndEditReducer(newState, action);
        case educationActions.DELETE_EDUCATION_SUCCESS: return deleteReducer(newState, action);
        case educationActions.GENERAL_EDUCATION_ERROR: return setEducationReducer(newState, action);
        default:
            return newState;
    }
}

function setEducationReducer(newState, action) {
    delete action.type;
    newState = Object.assign(newState, {...action});
    return newState;
}

function createAndEditReducer(newState, action) {
    delete action.type;
    delete action.body.type;

    const itemIndex = newState.body.find( item => item.id === action.body.id );

    if ( !itemIndex ) {
        newState.body.push( action.body )
    } else {
        newState.body[ newState.body.indexOf( itemIndex ) ] = action.body;
    }

    let arrCopy = [...newState.body], orderedArr = Date.orderByDate( arrCopy );

    newState.body = [...orderedArr];

    return newState;
}

function deleteReducer(newState, action) {
    delete action.type;
    newState.body = newState.body.filter(e => e.id !== action.body);
    return newState;
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/education.js